<template>
  <div>
    <DadminNavbar :online="online" @info="(v) => (showConnect = v)" />
    <TeoConnect v-show="showConnect" @online="(v) => (online = v)" />
    <div class="container">
      <component :is="currentView" />
    </div>
    <TeoFooter />
  </div>
</template>

<script>
import DadminNavbar from "./components/DadminNavbar.vue";
import TeoConnect from "./components/TeoConnect.vue";
import TeoFooter from "./components/TeoFooter.vue";

import PageHome from "./components/pages/PageHome.vue";
import PageInfo from "./components/pages/PageInfo.vue";
import MonitorApps from "./components/teo/monitor/MonitorApps.vue";
import PageCommands from "./components/pages/PageCommands.vue";
import TeoCrypt from "./components/teo/crypt/CryptDemo.vue";
import PageUsers from "./components/pages/PageUsers.vue";
import ActionGroups from "./components/ActionGroups.vue";
import ActionList from "./components/ActionList.vue";
import ItemsList from "./components/InventoryList.vue";
import FactionQuests from "./components/pages/FractionQuests.vue";
import PageNews from "./components/pages/PageNews.vue";
import PageWriteNews from "./components/pages/PageWriteNews.vue";
import PageImages from "./components/pages/PageImages.vue";
import PageLogs from "./components/pages/PageLogs.vue";

const routes = {
  "/": { page: PageHome, name: "Home" },
  "/apps": { page: MonitorApps, name: "Apps" },
  "/commands": { page: PageCommands, name: "Commands" },
  "/crypt": { page: TeoCrypt, name: "Crypt" },
  "/info": { page: PageInfo, name: "Info" },
  "/users": { page: PageUsers, name: "Users" },
  "/journal": { page: ActionList, name: "Journal" },
  "/action_group": { page: ActionList, name: "Action group" },
  "/action_groups": { page: ActionGroups, name: "Action groups" },
  "/items": { page: ItemsList, name: "Items" },
  "/fraction": { page: FactionQuests, name: "Fraction quests" },
  "/news": { page: PageNews, name: "News" },
  "/write_news": { page: PageWriteNews, name: "Write news" },
  "/images": { page: PageImages, name: "Images" },
  "/logs": { page: PageLogs, name: "Logs" },
};

export default {
  name: "App",
  components: {
    DadminNavbar,
    TeoConnect,
    TeoFooter,
  },

  data() {
    return {
      online: false,
      showConnect: true,
      currentPath: window.location.hash,
    };
  },

  computed: {
    currentView() {
      let path = this.currentPath.slice(1);
      let parts = path.split("/").slice(1);
      let route = routes["/" + parts[0] || "/"];
      if (!route) {
        route = {
          page: PageHome,
          name: "Home",
        };
      }

      document.title = route.name;
      return route.page;
    },
  },

  mounted() {
    let that = this;

    window.addEventListener("hashchange", () => {
      that.currentPath = window.location.hash;
    });
  },
};
</script>

<style>
/* Syles for whole application */

/* link color */
body a {
  color: #42b983;
}
/* hr color */
body hr {
  color: gray;
}
/* description class style */
.description {
  font-size: small;
  margin-bottom: 10px;
}

/* Use Icons inside input or text area */
/* enable addon class, and enable absolute positioning for addon */
.inner-addon {
  position: relative;
}
/* style addon */
.inner-addon .addon {
  position: absolute;
  display: flex;
  height: 100%;
  align-items: center;
  padding: 5px;
  cursor: pointer;
}
.inner-addon .addon i {
  height: unset;
}
/* align addon */
.addon {
  opacity: 0.5;
}
.addon-left {
  left: 0px;
  z-index: 100;
}
.addon-right {
  right: 50px;
  z-index: 100;
}
/* hover addon */
.addon:hover {
  opacity: 1;
}
</style>
